import { render, staticRenderFns } from "./TaskTabHeader.vue?vue&type=template&id=7811c888&scoped=true&"
import script from "./TaskTabHeader.vue?vue&type=script&lang=ts&"
export * from "./TaskTabHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TaskTabHeader.vue?vue&type=style&index=0&id=7811c888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7811c888",
  null
  
)

export default component.exports